import {name} from '@management-ui/core';
import React from 'react';
import Selected from '../../components/Slider/Selected';

const SelectedCustomer = (
  {
    session: {
      selectedCompany: company,
      selectedContact: contact,
      selectedEndUser: endUser
    }
  }
) => (
  <>
    {company ? (
      <Selected title="Company" value={company.name}/>
    ) : null}
    {contact ? (
      <Selected title="Contact" value={name(contact)}/>
    ) : ''}
    {endUser ? (
      <Selected title="End User" value={name(endUser)}/>
    ) : ''}
  </>
);

export default SelectedCustomer;
